<div>
  <dx-button #helpBtn icon="help" (onClick)="toggleHelpMenu()" hint="Hilfe"></dx-button>
  <dx-popover #dropDownButton
              [target]="helpBtn.instance.element()"
              id="account"
              position="bottom"
              [wrapperAttr]="{ class: 'my-popover' }"
              [width]="260"
              [showTitle]="false"
              [showCloseButton]="false"
              [hideOnOutsideClick]="true"
              [(visible)]="helpInfoVisible">

    <dx-list
      [items]="options"
      itemTemplate="helpItemTemplate"
      (onItemClick)="openHelpLink($event)">

      <div *dxTemplate="let item of 'helpItemTemplate'" class="help-item">
        <span
          [ngClass]="item.icon"
          class="help-item-icon">
          </span>
        <span class="help-item-text">
        {{ item.text }}
      </span>
        <span
          *ngIf="showExternalLinkImage(item.link)"
          class="glyphicon glyphicon-new-window help-item-icon-right">
        </span>
      </div>
    </dx-list>
  </dx-popover>
</div>




